app.directive('assetItem', [
    function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/directives/asset.html'
        }
    }]);